module.exports = __webpack_public_path__ + "img/运动健康之家3.0ea244f5.jpg";